export default __webpack_public_path__ + "static/media/carousel3.58a1525e.jpg";